class ZptProductFeatures {
  constructor(section) {
    this.section = section;

    this.bubble = section.querySelector(
      '[data-feature-bubble]'
    );

    this.slots = [
      ...section.querySelectorAll(
        '[data-feature-slot]'
      )
    ];

    this.cards = [
      ...section.querySelectorAll(
        '[data-feature-card]'
      )
    ].sort(
      (a, b) =>
        Number(a.dataset.featureIndex) -
        Number(b.dataset.featureIndex)
    );

    this.mobileQuery = window.matchMedia(
      '(max-width: 896px)'
    );

    this.mobileIndex = 0;
    this.desktopSlot = 0;

    this.startX = 0;
    this.startY = 0;
    this.pointerStarted = false;

    this.timer = null;

    this.onPointerDown =
      this.onPointerDown.bind(this);

    this.onPointerUp =
      this.onPointerUp.bind(this);

    this.onPointerCancel =
      this.onPointerCancel.bind(this);

    this.onKeyDown =
      this.onKeyDown.bind(this);

    this.onViewportChange =
      this.onViewportChange.bind(this);

    this.init();
  }

  init() {
    if (!this.bubble || !this.cards.length) {
      return;
    }

    this.bubble.addEventListener(
      'pointerdown',
      this.onPointerDown
    );

    this.bubble.addEventListener(
      'pointerup',
      this.onPointerUp
    );

    this.bubble.addEventListener(
      'pointercancel',
      this.onPointerCancel
    );

    this.bubble.addEventListener(
      'keydown',
      this.onKeyDown
    );

    this.mobileQuery.addEventListener(
      'change',
      this.onViewportChange
    );

    this.updateMobile();
    this.schedule();
  }

  updateMobile() {
    this.cards.forEach((card, index) => {
      const offset =
        (
          index -
          this.mobileIndex +
          this.cards.length
        ) % this.cards.length;

      card.dataset.mobileState =
        offset === 0
          ? 'active'
          : offset === 1
            ? 'next'
            : offset === 2
              ? 'back'
              : 'hidden';
    });

  }

  changeMobile(direction) {
    this.mobileIndex =
      (
        this.mobileIndex +
        direction +
        this.cards.length
      ) % this.cards.length;

    this.updateMobile();
    this.schedule();
  }

  rotateDesktop() {
    if (
      this.cards.length <= 3 ||
      this.bubble.matches(':hover')
    ) {
      return;
    }

    const rotatableSlots = this.slots.filter(
      (slot) =>
        slot.querySelectorAll(
          '[data-feature-card]'
        ).length > 1
    );

    if (!rotatableSlots.length) {
      return;
    }

    const slot =
      rotatableSlots[
        this.desktopSlot %
        rotatableSlots.length
      ];

    this.desktopSlot += 1;

    const slotCards = [
      ...slot.querySelectorAll(
        '[data-feature-card]'
      )
    ];

    const currentIndex =
      slotCards.findIndex(
        (card) =>
          card.classList.contains('is-active')
      );

    const current =
      slotCards[
        currentIndex < 0
          ? 0
          : currentIndex
      ];

    const next =
      slotCards[
        (
          currentIndex +
          1 +
          slotCards.length
        ) % slotCards.length
      ];

    if (!current || !next || current === next) {
      return;
    }

    current.classList.add('is-exiting');

    window.setTimeout(() => {
      current.classList.remove(
        'is-active',
        'is-exiting'
      );

      next.classList.add('is-active');
    }, 260);
  }

  schedule() {
    window.clearTimeout(this.timer);

    this.timer = window.setTimeout(() => {
      if (this.mobileQuery.matches) {
        this.changeMobile(1);
        return;
      }

      this.rotateDesktop();
      this.schedule();
    }, this.mobileQuery.matches ? 5200 : 4500);
  }

  onPointerDown(event) {
    if (!this.mobileQuery.matches) {
      return;
    }

    this.pointerStarted = true;
    this.startX = event.clientX;
    this.startY = event.clientY;
  }

  onPointerUp(event) {
    if (
      !this.mobileQuery.matches ||
      !this.pointerStarted
    ) {
      return;
    }

    this.pointerStarted = false;

    const dx =
      event.clientX - this.startX;

    const dy =
      event.clientY - this.startY;

    const absX = Math.abs(dx);
    const absY = Math.abs(dy);

    /*
      Normal vertical page scrolling should
      not rotate the feature deck.
    */
    if (
      absY > absX &&
      absY > 12
    ) {
      return;
    }

    if (absX > 40) {
      this.changeMobile(
        dx < 0 ? 1 : -1
      );

      return;
    }

    if (
      absX < 12 &&
      absY < 12
    ) {
      this.changeMobile(1);
    }
  }

  onPointerCancel() {
    this.pointerStarted = false;
  }

  onKeyDown(event) {
    if (!this.mobileQuery.matches) {
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.changeMobile(1);
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.changeMobile(-1);
    }
  }

  onViewportChange() {
    this.updateMobile();
    this.schedule();
  }
}


/* =========================================================
   INITIALIZATION
   ========================================================= */

const initZptProductFeatures = (
  root = document
) => {
  root
    .querySelectorAll(
      '[data-zpt-product-features]'
    )
    .forEach((section) => {
      if (
        section.dataset
          .zptProductFeaturesInitialized ===
        'true'
      ) {
        return;
      }

      section.dataset
        .zptProductFeaturesInitialized =
        'true';

      new ZptProductFeatures(section);
    });
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initZptProductFeatures()
  );
} else {
  initZptProductFeatures();
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initZptProductFeatures(
      event.target
    );
  }
);
